module.exports = require("codemirror/mode/xml/xml");